<template>
  <router-view/>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Funnel+Sans:ital,wght@0,300..800;1,300..800&display=swap');

* {
  font-family: "Funnel Sans"
}

#app {
  position: absolute;
  top: 0px;
  left: 0px;

  width: 100vw;
  height: 100vh;

  overflow: hidden;
}
</style>
